module.exports = __webpack_public_path__ + "assets1775130923925/img/lan5.01bd8a8d.png";